<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="form" :inline="true" status-icon label-width="130px" class="query-form" size="mini"
                 :rules="rules" :model="formData">
            <el-form-item label="分库名称:" class="query-form-item" prop="name">
                <el-input clearable v-model="formData.name" placeholder="请输入分库名称" size="mini"
                          style="width: 300px;"></el-input>
            </el-form-item>

            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="formData.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr_normal"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运输模式：" class="query-form-item">
                <el-select v-model="query.deliver_mode" placeholder="请选择" size="mini" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="item in $common.deliverModeArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="采购人员：" class="query-form-item">
                <el-select v-model="formData.developer_id" placeholder="请选择" size="mini">
                    <el-option label="暂不分配" value=""></el-option>
                    <el-option :label="item.full_name" :value="item.id" v-for="item in managerAnalysisList"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="wrapBox">
            <el-form ref="formData" :model="formData" label-width="180px" size="mini">
                <div class="top">
                    <div style="font-weight: 900;">下载模板</div>
                    <div>
                        <a href="/export/管理员批量上传Asin模板.xlsx"
                           style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“管理员批量上传Asin”模板</a>
                    </div>
                </div>
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        accept=".xls, .xlsx"
                        ref="upload"
                        :file-list="files"
                        :http-request="handleUpload"
                        :on-exceed='handExceed'
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :limit="1"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </el-form>
            <el-row class="bottomBox">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                >取 消
                </el-button>
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')">确定
                </el-button>
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {manager_build_selection_add, manager_index_get_category_message} from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            managerAnalysisList: [],
            categoryList: [],
            files: [],
            disabled: false,
            formData: {
                developer_id: '',
                deliver_mode: ''
            },
            textarea: '',
            date: [],
            dateArr: [
                {title: '最新日期区间', val: 2},
                {title: '最新日期', val: 1}
            ],
            dateType: 1,
            query: {
                state: '',
            },
            rules: {
                state: [
                    {
                        required: true,
                        message: '请选择国家',
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        required: true,
                        message: '请输入分库名称',
                        trigger: 'blur'
                    }
                ],
                // category_id: [
                //     {
                //         required: true,
                //         message: '请选择类目',
                //         trigger: 'blur'
                //     }
                // ],
                developer_id: [
                    {
                        required: true,
                        message: '请选择采购人员',
                        trigger: 'blur'
                    }
                ],
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
    },
    watch: {
        visible: {
            handler(val) {
                val && this.getManagerAnalysisList()
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        getManagerAnalysisList() {
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = (res.data || {}).map((item, key) => {
                        return {id: item.id, full_name: item.full_name + '-' + item.username}
                    })
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })

            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleUpload(raw) {
            this.files.push(raw.file)
        },
        handExceed(files, fileList) {
            this.$message({
                type: 'warning',
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                fileList.length} 个文件.`
            })
            return
        },
        handFileSuccess() {
            this.files = []
            this.$refs.upload.clearFiles()
        },
        handleRemove(file, fileList) {
            this.files = fileList
        },
        // 保存信息
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {

                    this.$refs.upload.submit() // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                    if (this.files.length == 0) {
                        this.$message.warning(`当前限制只能上传选择 1 个文件`)
                        return
                    }
                    let file = new FormData()
                    file.append('file', this.files[0])
                    file.append('name', this.formData.name)
                    file.append('state', this.formData.state)
                    // file.append('category_id', this.formData.category_id)
                    file.append('developer_id', this.formData.developer_id)
                    file.append('deliver_mode', this.formData.deliver_mode)
                    this.loading = true
                    api.manager_build_selection_add(file).then(res => {
                        if (res.code === 0) {
                            this.loading = false
                            this.$message({
                                type: 'success',
                                message: '添加成功'
                            })
                            this.handleClose(true)
                        } else {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                        .catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message:
                                    '网络出现问题，请查看数据是否添加完成！'
                            })
                        })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.files = []
            this.query.state = ''
            this.formData = {
                developer_id: '',
                deliver_mode: ''
            }
            this.dateType = 1
            this.textarea = ''
            this.date = []
            this.$emit('close-callback', isshow)
            this.disabled = false
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>
